<template>
  <i-modal
    :title="$t('editing', { value: $tc('product', 1) })"
    :value="value"
    :load="loading"
    @submit="submit"
    @input="$emit('input', $event)"
  >
    <v-row class="my-0">
      <v-col cols="12">
        <v-text-field
          outlined
          disabled
          :label="$tc('product', 1)"
          :value="productName"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <ValidationProvider
          vid="amount"
          :name="$tc('amount', 1)"
          rules="required|double:2"
          v-slot="{ errors }"
        >
          <v-text-field
            color="secondary"
            outlined
            type="number"
            min="0"
            :error-messages="errors[0]"
            :label="$tc('amount', 1)"
            v-model="form.quantity"
          />
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="6">
        <ValidationProvider
          vid="price"
          :name="$tc('price', 1)"
          rules="required|double:2"
          v-slot="{ errors }"
        >
          <i-money
            :error-messages="errors[0]"
            v-model="form.price"
            :label="$tc('price', 1)"
          />
        </ValidationProvider>
      </v-col>
    </v-row>
  </i-modal>
</template>
<script>
export default {
  name: 'DialEditProduct',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      loading: false,
      form: {
        quantity: 1,
        price: 0
      }
    }
  },
  computed: {
    productName() {
      if (!this.product) {
        return ''
      }
      return this.product.own_prod || this.product.name || ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val && this.product) {
          this.form = {
            quantity: this.product.quantity,
            price: this.product.price
          }
        }
      }
    }
  },
  methods: {
    async submit() {
      if (this.loading || !this.product) {
        return
      }
      try {
        this.loading = true
        const quantity = Number(this.form.quantity)
        const price = Number(this.form.price)
        const response = await this.$api.purchase.product.edit({
          pk: this.product.pk,
          form: {
            ...this.product,
            quantity,
            price,
            pending_quantity: quantity
          }
        })
        this.$emit('done', response.data)
        this.$emit('input', false)
        this.$toast.success(
          `${this.$tc('product', 1)} ${this.$tc('edited', 2)}`
        )
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
